import { render, staticRenderFns } from "./ServiceElderByAge.vue?vue&type=template&id=a1eaf1e4&scoped=true&"
import script from "./ServiceElderByAge.vue?vue&type=script&lang=js&"
export * from "./ServiceElderByAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1eaf1e4",
  null
  
)

export default component.exports